import moment from "moment";
import { ApiEndpoint } from "../../env.config";
import { SetError } from "./SystemAction";
import { authFetch } from "../../shared/utils/fetchUtils";
import { resetLoading } from "./RoadAction";

export const GisType = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  GET_SURVEYEDDETAIL_SUCCESS: "GET_SURVEYEDDETAIL_SUCCESS",
  TOGGLE_SHOW_SIDE_CONTENT: "TOGGLE_SHOW_SIDE_CONTENT",
  SET_SURVEYED_MAP_TYPE: "SET_SURVEYED_MAP_TYPE",
  MAP_LOADED: "MAP_LOADED",
  PREDICTED: "PREDICTED",
  ACTUAL: "ACTUAL",
  POINT_POPUP: "POINT_POPUP",
  RESET_DATATYPE: "RESET_DATATYPE"
};

export const loading = () => ({
  type: GisType.LOADING,
});

export const GetSurveyedDetailSuccess = (data) => ({
  type: GisType.GET_SURVEYEDDETAIL_SUCCESS,
  data: data,
});

export const ToggleShowHideSideContent = () => ({
  type: GisType.TOGGLE_SHOW_SIDE_CONTENT,
});

export const setSurveyedMapType = (value) => ({
  type: GisType.SET_SURVEYED_MAP_TYPE,
  value: value,
});

export const GisError = () => ({
  type: GisType.ERROR,
});

export const mapLoaded = (value) => ({
  type: GisType.MAP_LOADED,
  value: value
});

export const setIsPredicted = (value) => ({
  type: GisType.PREDICTED,
  value: value
});

export const setIsActual = (value) => ({
  type: GisType.ACTUAL,
  value: value
});

export const setPointPopup = (value) => ({
  type: GisType.POINT_POPUP,
  value: value
});

/**
 * Actual/Predictedの状態リセット
 * @returns
 */
export const resetDataType = () => ({
  type: GisType.RESET_DATATYPE
});

const setSystemError = SetError;

/**
 * 属性検索API呼び出し
 * @param {*} date 調査日付
 * @param {*} pos 調査位置(ポップアップ位置)
 * @param {*} kp 調査位置ID
 * @param {function} closeSurveyedDetail index.jsより、ポップアップクローズ関数
 * @param {function} setIsClick Map.jsより、地物クリック判定のセット関数
 * @returns
 */
export const GetSurveyedDetail = (date, pos, kp, transObj, closeSurveyedDetail, setIsClick) => {
  return function (dispatch, getState) {
    const { userFilter, yearFilter, rankFilters } = getState().road;
    const { surveyedMapType, isActual, isPredicted } = getState().gis;
    const { surfaceFilters } = getState().surface;
    const loggedUser = getState().auth.user;
    dispatch(loading());

    // PStr = param string
    const yearFilterPStr = `year=${yearFilter}`;
    const rankFiltersPStr = rankFilters?.length > 0 ? `&rankFilterIds=${rankFilters.map(s => s.id).join(",")}` : ``;
    const surfaceFiltersPStr = surfaceFilters?.length > 0 ? `&surfaceFilters=${surfaceFilters.map(d => d.title).join(",")}` : ``;
    let apFilterPStr = ``;
    if (!isActual && isPredicted) {
      apFilterPStr = `&apFilter=p`;
    } else if (isActual && !isPredicted) {
      apFilterPStr = `&apFilter=a`;
    }
    const latLngPStr = (transObj && transObj.point) ? `&lat=${transObj.point.lat}&lng=${transObj.point.lng}` : ""; // ラインクリック時のみ使用

    const userId = userFilter || loggedUser.id;
    const dateString = moment(date, "YYYY-MM-DD").format("DDMMYYYY");
    let url = "";

    // 試験的に分岐、いずれkp式のみ残す
    let isKpSearch = true;
    if (isKpSearch) {
      url = `${ApiEndpoint}/Road/surveyed/detail/${surveyedMapType}/${userId}/${dateString}/kp/${kp}?${yearFilterPStr}${rankFiltersPStr}${surfaceFiltersPStr}${latLngPStr}${apFilterPStr}`.replaceAll(" ", "");
    } else {
      const lat = pos[0];
      const lng = pos[1];
      url = `${ApiEndpoint}/Road/surveyed/detail/${surveyedMapType}/${userId}/${dateString}/${lat}/${lng}?${yearFilterPStr}${rankFiltersPStr}${surfaceFiltersPStr}${latLngPStr}${apFilterPStr}`.replaceAll(" ", "");
    }
    return authFetch(
      url,
      { method: "GET" }
    ).then((json) => {
      // ポップアップ位置のstate化
      if (json.surveyedData && json.surveyedData.latitude && json.surveyedData.longitude) {
        const nextPointPopup = [json.surveyedData.latitude, json.surveyedData.longitude];
        dispatch(setPointPopup(nextPointPopup));
      }
      if (json.surveyedData == null && closeSurveyedDetail != null && setIsClick != null) {
        // データが取れなかった場合、ポップアップをクローズする
        setIsClick(false);
        closeSurveyedDetail();
      } else {
        dispatch(GetSurveyedDetailSuccess(json));
      }
      dispatch(resetLoading());
    }).catch((err) => {
      dispatch(resetLoading());
      dispatch(GisError(err));
      dispatch(setSystemError(err));
    });
  };
}


/**
 * API取得結果から ベクタタイルのidとsourceLayer情報を取得
 * @param {string} aForceType 強制的にレイヤタイプ(point or line)を指定する場合(未指定時は自動判別)
 * @returns ベクタタイル情報({id: ~, name: ~ })
 */
export const getVectorSourceInfo = (aVectorTiles, aSurveyedMapType) => {
  let sourceInfo = {
    id: "",
    name: ""
  }

  if (aVectorTiles == null || aSurveyedMapType == null) return sourceInfo;

  if (aSurveyedMapType === "point" && aVectorTiles.point != null) {
    sourceInfo = aVectorTiles.point;
  } else if (aSurveyedMapType === "line" && aVectorTiles.line?.normal != null && aVectorTiles.line.normal.name != null) {
    sourceInfo = aVectorTiles.line.normal; // 5point方式
  } else if (aSurveyedMapType === "line" && aVectorTiles.line?.summary != null && aVectorTiles.line.summary.name != null) {
    sourceInfo = aVectorTiles.line.summary; // summary方式
  }
  return sourceInfo;
}
